import React, { useState } from 'react';
import { Box, Button, Card, CardContent, TextField, Typography, Switch, Grid } from '@mui/material';

const SecurityPage = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);

  const handle2FAToggle = () => {
    setIs2FAEnabled(!is2FAEnabled);
  };

  const handlePasswordChange = () => {
    // Handle password change logic here
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '100vh',
        backgroundColor: 'background.default',
        padding: { xs: 2, sm: 4 },
      }}
    >
      <Card
        sx={{
          width: { xs: '90%', sm: '70%', md: '50%', lg: '40%' },
          padding: { xs: 3, sm: 4 },  // Increased padding for more space
          backgroundColor: '#ffffff',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
          borderRadius: '12px',
          marginTop: '20px',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            textAlign: 'center',
            marginBottom: 3,
            fontWeight: 'bold',
            color: 'text.primary',
            fontSize: { xs: '20px', md: '24px' },
          }}
        >
          Security Settings
        </Typography>

        <CardContent>
          {/* Password Change Section */}
          <Box>
            <Typography variant="h6" sx={{ marginBottom: 2, color: 'text.primary' }}> {/* Increased margin */}
              Change Password
            </Typography>

            <Grid container spacing={2}>  {/* Increased spacing between grid items */}
              <Grid item xs={12}>
                <TextField
                  label="Old Password"
                  variant="outlined"
                  type="password"
                  fullWidth
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="New Password"
                  variant="outlined"
                  type="password"
                  fullWidth
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Confirm New Password"
                  variant="outlined"
                  type="password"
                  fullWidth
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  size="small"
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 3,  // Increased margin for more space
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handlePasswordChange}
                sx={{
                  padding: '10px 20px',  // Adjusted button padding
                  fontSize: '14px',
                  borderRadius: '8px',
                }}
              >
                Change Password
              </Button>
            </Box>
          </Box>

          {/* 2FA Section */}
          <Box sx={{ marginTop: 5 }}> {/* Increased margin for more space */}
            <Typography variant="h6" sx={{ marginBottom: 2, color: 'text.primary' }}>
              Two-Factor Authentication (2FA)
            </Typography>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: 'action.hover',
                padding: 2,
                borderRadius: '8px',
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Typography
                variant="body1"
                sx={{ color: 'text.primary', fontWeight: '500' }}
              >
                Enable Two-Factor Authentication
              </Typography>

              <Switch
                checked={is2FAEnabled}
                onChange={handle2FAToggle}
                color="primary"
              />
            </Box>

            {is2FAEnabled && (
              <Typography
                variant="caption"
                sx={{ marginTop: 1, display: 'block', color: 'text.secondary' }}
              >
                You have enabled 2FA for your account.
              </Typography>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SecurityPage;
